"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BarcodeScanPanel;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const useBarcodeScanner_1 = require("./useBarcodeScanner");
const trackingNumber_1 = require("./trackingNumber");
const STATUS_TEXT = {
    idle: "",
    starting: "Uruchamiam kamerę…",
    scanning: "Przyłóż kod kreskowy z potwierdzenia nadania.",
    denied: "Brak zgody na dostęp do kamery. Numer możesz wpisać ręcznie.",
    unavailable: "Ta przeglądarka nie udostępnia kamery. Numer możesz wpisać ręcznie.",
    error: "Nie udało się uruchomić kamery. Numer możesz wpisać ręcznie.",
};
/**
 * Skanowanie numerów nadania z kamery.
 *
 * Panel zostaje otwarty po udanym odczycie, żeby stos potwierdzeń dało się przeskanować
 * jedno po drugim bez klikania. Numer, który nie przejdzie cyfry kontrolnej, nie trafia
 * na listę — pokazujemy prośbę o ponowne przyłożenie zamiast wpuszczać zły odczyt.
 */
function BarcodeScanPanel({ knownNumbers, onScanned, }) {
    const [active, setActive] = (0, react_1.useState)(false);
    const { videoRef, status, rejection, acceptedCount } = (0, useBarcodeScanner_1.useBarcodeScanner)({
        active,
        knownNumbers,
        onAccepted: onScanned,
    });
    if (!active)
        return (react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-primary", onClick: () => setActive(true) },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCamera, className: "me-2" }),
            "Skanuj potwierdzenia"));
    const cameraFailed = status === "denied" || status === "unavailable" || status === "error";
    return (react_1.default.createElement(react_bootstrap_1.Card, null,
        react_1.default.createElement(react_bootstrap_1.Card.Body, null,
            react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center mb-2" },
                react_1.default.createElement("span", { className: "fw-semibold" }, "Skanowanie potwierdze\u0144"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", onClick: () => setActive(false) },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faStop, className: "me-2" }),
                    "Zako\u0144cz")),
            !cameraFailed && (react_1.default.createElement("video", { ref: videoRef, muted: true, playsInline: true, style: {
                    width: "100%",
                    maxHeight: 260,
                    objectFit: "cover",
                    background: "#000",
                    borderRadius: 4,
                } })),
            react_1.default.createElement("div", { className: "text-muted small mt-2" }, STATUS_TEXT[status]),
            rejection && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "py-2 mt-2 mb-0" }, trackingNumber_1.REJECTION_MESSAGES[rejection])),
            acceptedCount > 0 && (react_1.default.createElement("div", { className: "text-success small mt-2" },
                "Zeskanowano list\u00F3w: ",
                acceptedCount)))));
}
